import { useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import { surveyGroupFilterAtom } from '~/atoms'
import { useCurrentSurveyGroupIdState } from '~/hooks/useCurrentSurveyGroupIdState'
import { assertExists } from '~/utils'

export const useCreateSurveyGroupFilterRestoringParams = () => {
  const { t } = useTranslation()
  const { brandAccountId } = useParams<{ brandAccountId: string | undefined }>()
  const [surveyGroupId] = useCurrentSurveyGroupIdState()
  const surveyGroupFilter = useAtomValue(surveyGroupFilterAtom)

  return React.useCallback(
    <RestoringParams>(path: string, state: RestoringParams) => {
      assertExists(brandAccountId, t('assertion_failed'))

      return {
        brandAccountId,
        replace: {
          path: compile('restoreSurveyGroupFilter', { brandAccountId }),
          state: {
            surveyGroupFilter: {
              surveyGroupId,
              filterGroups: surveyGroupFilter?.filterGroups ?? [],
            },
            replace: { path, state },
          },
        },
      }
    },
    [brandAccountId, surveyGroupFilter?.filterGroups, surveyGroupId, t],
  )
}
